import { render, staticRenderFns } from "./RecomPromoCodeCreate.vue?vue&type=template&id=61c9ff59"
import script from "./RecomPromoCodeCreate.vue?vue&type=script&lang=js"
export * from "./RecomPromoCodeCreate.vue?vue&type=script&lang=js"
import style0 from "./RecomPromoCodeCreate.vue?vue&type=style&index=0&id=61c9ff59&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports